import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-211">
      {isOpen && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-212">
          {/* Overlay */}
          <div className="absolute inset-0 bg-[#2B2724]/40 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-213" />

          {/* Dialog */}
          <motion.div role="dialog" aria-modal="true" aria-label={title} className="relative z-10 w-full max-w-[640px] max-h-[85vh] flex flex-col bg-surface rounded-[16px] border border-border shadow-[0_24px_64px_rgba(43,39,36,0.18)] overflow-hidden" initial={{
        opacity: 0,
        y: 24,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} data-id="element-214">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-border-light flex-shrink-0" data-id="element-215">
              <h2 className="font-serif font-bold text-[22px] text-text-primary" data-id="element-216">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 flex items-center justify-center rounded-full text-text-secondary hover:bg-cream hover:text-text-primary transition-colors" data-id="element-217">
                <X className="w-5 h-5" strokeWidth={1.5} data-id="element-218" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 md:px-8 py-6 overflow-y-auto text-text-secondary" data-id="element-219">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}